module.exports = __webpack_public_path__ + "static/media/setting__reset.f34be0bd.svg";